import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppServiceService } from 'src/app/api/app-service.service';
import { DatePipe } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { SelectOrderTypePage } from "../modals/select-order-type/select-order-type.page";
import { TranslateService } from '@ngx-translate/core';
import { CartPage } from '../modals/cart/cart.page';
import { OTPVerificationPage } from '../modals/otp-verification/otp-verification.page';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {
  @Output() onNavigatePages: EventEmitter<any> = new EventEmitter();
  @Output() onChangeDeliveryAddress: EventEmitter<any> = new EventEmitter();
  @Output() onOrderPlaced: EventEmitter<any> = new EventEmitter();
  @Input() backFromAddressSelect = false;
  // user decide to go back and login to the account for purchase rewards (points system change for web version)
  @Output() onBackLoginFromCheckout: EventEmitter<any> = new EventEmitter();

  @ViewChild('googleaddressbackary', { read: oninput }) googleaddressbackary: HTMLInputElement;

  @HostBinding('style.--radio-color')
  public radioColor: any = this.appService.appObject?.theme[this.appService.themeConfigFor]?.primaryColor ? this.appService.appObject?.theme[this.appService.themeConfigFor]?.primaryColor : '';

  public selectedRadio = '';
  todayDate: any;
  minDate: any;
  maxDate: any;
  selectedDate: any;
  deleveryAvailableTimes: any = [];
  deliveryDates: any = [];
  selectedTimes: any = [];
  firstTime: boolean = true;
  street_number: string = '';
  showSelectAddressError: boolean = false;
  house_number: string = '';

  // start postal code feature 
  public deliveryAddress: string = '';
  public postalCodeDetails: any = null;
  // end postal code feature 

  selectedTimesLoading: boolean = true;

  checkoutForm = null;
  deliveryMethod = this.appService.appObject.selectedDeliveryMethod;

  currentlySelectedAddress = '';
  public isBarModeEnabled: boolean = false;

  // point system related
  public userPoints: any = null;
  public isOrderAmountPointsReached: boolean = false;
  public totalPointRequirement: string = '';
  public isMinimumPointsAmountReached: boolean = false;
  public pointConfig: any = null;
  public lang: any = null;

  public showSelectPaymentError: boolean = false;

  public displayAsapOption: boolean = false;

  public showMenuCategoriesNotAvailableError = false;
  public unavailableMenus: any[] = []

  public is_subscription_order: boolean = false;
  public order_schedule_type: string = '';
  public order_days: any = [];
  public is_end_date: boolean = false;
  public end_date: string = '';
  public start_date: string = '';
  public showSelectScheduleTypeError: boolean = false;
  public showSelectDaysError: boolean = false;
  public showSelectEndDateError: boolean = false;
  public showEndDateGrateError: boolean = false;
  public showSelectSartDateError: boolean = false;
  public daynumber: number = 0;
  public subscription_order_cutoff_time: any = '';
  public subscription_order_cutoff_days: any = '';
  public suggest_start_day: any = '';
  public available_days: any = '';
  // predefined week days as in menu category availability configurations
  public daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  public verificationInProgress: boolean = false;

  /**
   * Address book data of the user
   */
  public userAddressesList: any[] = [];
  public postalCodeAddress: any[] = [];
  public normalAddress: any[] = [];
  public userDetailsLoading: boolean = false;
  public changingAddressInProgress: boolean = false;
  public addressSelectActionTriggered: boolean = false;
  public defaultOrderType: string;
  public subDisabled: boolean = false;
  private isAboutToTriggerStartDateChange: boolean = false;

  private debugOn = true;

  constructor(public appService: AppServiceService, private datePipe: DatePipe, private router: Router, public modalController: ModalController, public translate: TranslateService) {
    this.canRoute();

    this.appService.className2 = ' cart-top';

    setTimeout(() => {
      this.getDeliveryTimes();
      let defaultPaymentMethod = this.appService.appObject.selectedRestaurantDetails.payment_methods.find((method) => method.id === this.appService.appObject.selectedRestaurantDetails.default_payment_method);

      // check if the selected default payment method is available for selected ordering type
      // if not no payment method will be selected
      if (defaultPaymentMethod && defaultPaymentMethod['is_' + this.appService.appObject.selectedDeliveryMethod] === 'true') {
        this.checkoutForm.value.payment_type = this.appService.appObject.selectedRestaurantDetails.default_payment_method;
        this.selectedRadio = this.appService.appObject.selectedRestaurantDetails.default_payment_method;
      }

      if (this.appService.appObject.isAuthed) {
        this.getUserDetails();
      } else {
        this.updateFormData();
      }

      let subscription_order_button = this.appService.appObject.selectedRestaurantDetails.subscription_order_button;
      let general_order_button = this.appService.appObject.selectedRestaurantDetails.general_order_button;
      this.defaultOrderType = this.appService.appObject.selectedRestaurantDetails.default_order_type;

      if (subscription_order_button === 'true' && general_order_button !== 'true') {
        this.subDisabled = true;
      }

      if (this.defaultOrderType === '"general_order"') {
        this.is_subscription_order = false;
      }
      if (this.defaultOrderType === 'subscription_order') {
        this.is_subscription_order = true;
      }

    }, 1000);

    var cutofftime = this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_time;
    if (cutofftime !== null) {
      this.subscription_order_cutoff_time = JSON.parse(this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_time)?.subscription_order_cutoff_time;
      this.subscription_order_cutoff_days = this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_day;
      this.available_days = JSON.parse(this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_time)?.available_days;
    }

    this.currentlySelectedAddress = this.appService.appObject.myAddress && this.appService.appObject.myAddress.name ? this.appService.appObject.myAddress.name : '';

    if (this.backFromAddressSelect) {
      this.onDismissAddressSelect();
    }

    this.validator();

    // auto fill the street number if available from previousely selected valid address
    this.street_number = appService.appObject.myAddress && appService.appObject.myAddress.streetNo ? appService.appObject.myAddress.streetNo : '';

    if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.is_bar_mode === 'true') {
      this.isBarModeEnabled = true;
    }

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.settings.is_postalcode === 'true') {
      // console.log('postal code details : ', this.appService.appObject.postalCodeDetails);
      this.postalCodeDetails = this.appService.appObject.postalCodeDetails;
    }

    setTimeout(() => {
      this.appService.initGoogleBakery(this.googleaddressbackary);
      this.appService.appObject.isLoading = false;
    }, 2000);

    this.getLang();
  }

  ngDoCheck() {
    this.radioColor = this.appService.appObject.theme[this.appService.themeConfigFor]?.primaryColor || '';
  }

  validator() {

    // form validators
    // check if the mobile number is required by the restaurant when placing an order
    let isMobileNumberRequired = this.appService.appObject.selectedRestaurantDetails ? this.appService.appObject.selectedRestaurantDetails.is_mobile_number : false;

    let mobileNumberValidations = isMobileNumberRequired === 'true' ? [Validators.required] : [];
    mobileNumberValidations.push(Validators.minLength(9));
    mobileNumberValidations.push(Validators.maxLength(30));
    mobileNumberValidations.push(Validators.pattern(/(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))/));

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
      // set all the form validators
      this.checkoutForm = new FormGroup({
        name: new FormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(/\w+\s\w+/)
          ],
          updateOn: 'change'
        }),
        mobile_number: new FormControl('', {
          validators: mobileNumberValidations,
          updateOn: 'change'
        }),
        email: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
          ],
          updateOn: 'change'
        }),
        special_note: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        payment_method: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_date: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_time: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        address: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        street_number: new FormControl('', {
          validators: [
            Validators.required,
          ],
          updateOn: 'change',
        }),
        // house_number: new FormControl('', {
        //   validators: [
        //     Validators.required,
        //   ],
        //   updateOn: 'change',
        // }),
        is_subscription_order: new FormControl(false, {
          validators: [],
          updateOn: 'change',
        }),
        order_schedule_type: new FormControl('weekly', {
          validators: [],
          updateOn: 'change',
        }),
        order_days: new FormControl([], {
          validators: [],
          updateOn: 'change',
        }),
        is_end_date: new FormControl(false, {
          validators: [],
          updateOn: 'change',
        }),
        end_date: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        // start_date: new FormControl(this.nextDay(), {
        start_date: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        suggest_start_day: new FormControl('', {
          validators: [],
          updateOn: 'change',
        })
      });
    } else if (this.appService.appObject.selectedDeliveryMethod === 'delivery') {
      // set all the form validators
      this.checkoutForm = new FormGroup({
        name: new FormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(/\w+\s\w+/)
          ],
          updateOn: 'change'
        }),
        mobile_number: new FormControl('', {
          validators: mobileNumberValidations,
          updateOn: 'change'
        }),
        email: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
          ],
          updateOn: 'change'
        }),
        backyard: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        special_note: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        payment_method: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_date: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_time: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        street_number: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^[0-9]*$"),
          ],
          updateOn: 'change',
        }),
        is_subscription_order: new FormControl(false, {
          validators: [],
          updateOn: 'change',
        }),
        order_schedule_type: new FormControl('weekly', {
          validators: [],
          updateOn: 'change',
        }),
        order_days: new FormControl([], {
          validators: [],
          updateOn: 'change',
        }),
        is_end_date: new FormControl(false, {
          validators: [],
          updateOn: 'change',
        }),
        end_date: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        // start_date: new FormControl(this.nextDay(), {
        start_date: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        suggest_start_day: new FormControl('', {
          validators: [],
          updateOn: 'change',
        })
      });
    } else {
      // set all the form validators
      this.checkoutForm = new FormGroup({
        name: new FormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(/\w+\s\w+/)
          ],
          updateOn: 'change'
        }),
        mobile_number: new FormControl('', {
          validators: mobileNumberValidations,
          updateOn: 'change'
        }),
        email: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
          ],
          updateOn: 'change'
        }),
        backyard: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        special_note: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        payment_method: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_date: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_time: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        is_subscription_order: new FormControl(false, {
          validators: [],
          updateOn: 'change',
        }),
        order_schedule_type: new FormControl('weekly', {
          validators: [],
          updateOn: 'change',
        }),
        order_days: new FormControl([], {
          validators: [],
          updateOn: 'change',
        }),
        is_end_date: new FormControl(false, {
          validators: [],
          updateOn: 'change',
        }),
        end_date: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        // start_date: new FormControl(this.nextDay(), {
        start_date: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        suggest_start_day: new FormControl('', {
          validators: [],
          updateOn: 'change',
        })
      });
    }
    this.minDate = this.checkoutForm.value.start_date;

  }

  canRoute() {
    if (this.appService.appObject.deviceUUID == "") {
      setTimeout(() => {
        if (this.appService.appObject.orderObject.cart.length == 0) {
          this.appService.routeToSelectedRestaurant();
        }
      }, 100);
    }
  }

  ionViewWillEnter() {
    this.appService.hideCartButton = false;
  }

  onChangeHandler($event) {
    this.checkoutForm.value.payment_type = $event.target.value;
  }

  ionViewWillLeave() {
    console.log('leaveng');
    this.appService.hideCartButton = true;
    this.appService.className2 = ' ';
  }

  getUserDetails() {
    this.userPoints = null;
    this.userDetailsLoading = true;

    this.appService.getUserDetails({ 'customer_id': this.appService.appObject.userId }).then((data: any) => {
      if (data.status) {
        this.appService.appObject.user.fname = data.data.first_name;
        this.appService.appObject.user.lname = data.data.last_name;
        this.appService.appObject.user.email = data.data.email;
        this.appService.appObject.user.telephone = data.data.mobile_number;
        this.updateFormData();

        // get user's reward points 
        if (data.data.points && data.data.points !== '[]') {
          let userPoints = JSON.parse(data.data.points);
          Object.keys(userPoints).map((key) => {
            // get the usable points for selected restaurant
            if (key === (this.appService.appObject.selectedRestaurantId + '')) {
              // remove decimals 
              userPoints[key].points = userPoints[key].points ? userPoints[key].points.toFixed(0) : userPoints[key].points;
              this.userPoints = userPoints[key];
            }
          });


          // points system related
          let restaurantPaymentMethods = this.appService.appObject.selectedRestaurantDetails.payment_methods;
          let pointsEnabled = restaurantPaymentMethods.find((method) => method.id === 'points' && method.isActive === 'true');
          if (this.userPoints && pointsEnabled && pointsEnabled.config && this.appService.appObject.orderObject.cart_summery && this.appService.appObject.orderObject.cart_summery.gross_total) {
            this.pointConfig = pointsEnabled.config;
            let grossTotal = this.appService.appObject.orderObject.cart_summery.gross_total;
            // console.log('pointConfig : ' , pointConfig);

            let pointValue = (+this.pointConfig.valueInPoints) / (+this.pointConfig.valueInCurrency);
            let totalPointRequirement = grossTotal * pointValue;
            this.isOrderAmountPointsReached = (this.userPoints.points >= totalPointRequirement) ? true : false;

            // check the minimum point amount reached
            this.isMinimumPointsAmountReached = (totalPointRequirement >= (+this.pointConfig.minPoints)) ? true : false;

            this.totalPointRequirement = totalPointRequirement.toFixed(0);
            // console.log('this.isOrderAmountPointsReached : ' , this.isOrderAmountPointsReached , ' | totalPointRequirement : ' , totalPointRequirement, ' | ',this.userPoints.points);
          }
        }

        // get user address book data
        if (data.data.addressBook) this.userAddressesList = data.data.addressBook;
        else this.userAddressesList = [];

        this.postalCodeAddress = this.userAddressesList.filter((addressC) => addressC.is_postalcode_mode === 'true');
        this.normalAddress = this.userAddressesList.filter((addressC) => addressC.is_postalcode_mode !== 'true');
      }
    }).finally(() => this.userDetailsLoading = false);
  }

  updateFormData() {
    this.checkoutForm.get('name').setValue(this.appService.appObject.user.fname + ' ' + this.appService.appObject.user.lname);
    this.checkoutForm.get('email').setValue(this.appService.appObject.user.email);
    this.checkoutForm.get('mobile_number').setValue(this.appService.appObject.user.telephone);

    if (this.appService.appObject.settings.is_postalcode === 'true' && this.appService.appObject.postalCodeExtraDetails) {
      this.checkoutForm.get('address').setValue(this.appService.appObject.postalCodeExtraDetails.address);
      this.checkoutForm.get('street_number').setValue(this.appService.appObject.postalCodeExtraDetails.streetNumber);
    }
  }

  async placeOrder() {

    // <---------------- Verification START ----------------->
    let verificationFail = false;

    if (this.appService.appObject.userVerificationRequired && !this.appService.appObject.user.is_verified) {

      this.verificationInProgress = true;

      let verificatioData = { mobile_number: this.appService.appObject.user.telephone, email: this.appService.appObject.user.email };
      // request verification code, will check in backend for the method mobile / email and send back the method
      await this.appService.requestVerificationCode(verificatioData).then(async (verificationResponse) => {
        // if verification code has been sent, will return the what method used to sent 
        if (verificationResponse.status) {
          this.appService.startVerificationCodeIntervalCountdown();

          // open otp verification popup
          const cartModal = await this.modalController.create({
            component: OTPVerificationPage,
            cssClass: 'custom-popup',
            componentProps: {
              userData: verificatioData,
              operationType: 'checkout-verification',
              previousCodeSentVia: verificationResponse.sentVia
            }
          });

          await cartModal.present();
          // on dismiss check returned data 
          await cartModal.onDidDismiss().then((response: any) => {

            this.verificationInProgress = false;

            if (response.data && response.data.isVerified) {
              this.appService.appObject.user.is_verified = response.data.isVerified;
              this.appService.updateAppObject();
            } else {
              verificationFail = true;
              return;
            }
          });
        }
      }).catch((error) => {
        this.verificationInProgress = false;
        verificationFail = true;
        return;
      });
    }

    if (verificationFail) {
      if (this.debugOn) console.log('validation failed');
      return;
    }
    // <---------------- Verification END ----------------->

    // check if user has already claimed the welcome gift pacakge, if has remove it from the orderobject
    if (!this.appService.appObject.loggedInUserData || !this.appService.appObject.loggedInUserData.eligible_for_welcome_order) {
      this.appService.appObject.orderObject.claimWelcomePackage = false;
    }

    if (this.is_subscription_order) {
      if (!this.checkoutForm.value.order_schedule_type) {
        this.showSelectScheduleTypeError = true;
        if (this.debugOn) console.log('am called 2');
        return;
      }
      // if (this.checkoutForm.value.order_schedule_type === 'daily') {
      //   this.checkoutForm.value.order_days = this.appService.appObject.selectedRestaurantDetails['available_days'];
      // }

      this.showSelectDaysError = false;
      if (this.checkoutForm.value.order_days.length <= 0) {
        this.showSelectDaysError = true;
        if (this.debugOn) console.log('am called 3');
        return;
      }

      this.showSelectSartDateError = false;
      if (this.checkoutForm.value.start_date === '') {
        if (this.debugOn) console.log('am called 4');
        this.showSelectSartDateError = true;
        return;
      }

      this.showSelectEndDateError = false;
      if (this.checkoutForm.value.is_end_date && !this.checkoutForm.value.end_date) {
        if (this.debugOn) console.log('am called 5');
        this.showSelectEndDateError = true;
        return;
      }

      this.showEndDateGrateError = false;
      if (Date.parse(this.checkoutForm.value.start_date) > Date.parse(this.checkoutForm.value.end_date)) {
        if (this.debugOn) console.log('am called 6');
        this.showEndDateGrateError = true;
        return;
      }
    }
    
    // 2023-09-04
    // check selected dish categories availability
    this.showMenuCategoriesNotAvailableError = false;
    if (this.checkMenuCategoriesAvailability()) {
      this.showMenuCategoriesNotAvailableError = true;
      if (this.debugOn) console.log('am called 2');
      return;
    }

    // 2022-12-01 since today there is a new feature to enable or disable payment options for specific ordering type
    // so added new validation to make sure that the user has selected a payment option
    if (!this.checkoutForm.value.payment_method) {
      this.showSelectPaymentError = true;
      if (this.debugOn) console.log('am called 1');

      return;
    }
    this.showSelectPaymentError = false;
    // end payment option select validation

    // added another condition to point payment gateway, just in case
    if (this.checkoutForm.value.payment_method === 'points' && this.appService.appObject.selectedDeliveryMethod === 'dine_in' && this.appService.appObject.selectedRestaurantDetails.is_bar_mode === 'true' && (!this.isOrderAmountPointsReached || !this.isMinimumPointsAmountReached)) return;

    // Postal code mode validations 
    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
      if (this.appService.appObject.postalCodeDetails) {
        let listOfPostalCodes = this.appService.appObject.selectedRestaurantDetails.postal_code_details;
        if (listOfPostalCodes) {
          if (!Array.isArray(listOfPostalCodes)) listOfPostalCodes = JSON.parse(listOfPostalCodes);
          let selectedExists = listOfPostalCodes.find((postalCode) => postalCode.code === this.appService.appObject.postalCodeDetails.code);
          if (!selectedExists) {
            this.appService.showToast(this.lang.selected_restaurent_not_delivery_city, 'danger');
            return;
          }
          else console.log('postal code supported');
        } else {
          // show error
          this.appService.showToast(this.lang.selected_restaurent_not_delivery_city, 'danger');
          return;
        }
      } else {
        // show error
        console.log('postal code not selected by user');
        return;
      }
    }

    this.showSelectAddressError = false;
    // console.log(this.checkoutForm);
    this.checkoutForm.markAsTouched();
    this.checkoutForm.controls['name'].markAsTouched();
    this.checkoutForm.controls['email'].markAsTouched();
    this.checkoutForm.controls['mobile_number'].markAsTouched();
    this.checkoutForm.controls['delivery_date'].markAsTouched();
    this.checkoutForm.controls['delivery_time'].markAsTouched();

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery') this.checkoutForm.controls['street_number'].markAsTouched();

    // if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') this.checkoutForm.controls['house_number'].markAsTouched();

    // this is a trick to fool checkout form validity check 
    // when its subscription order, if there are no values are set to delivery date and time 
    // then checkout valid will fail, order won't be able to place, to avoid that we use this trick
    // if resetDataInDeliveryDateTime is true then once checkout form validity pass reset delivery date and time to empty
    let resetDataInDeliveryDateTime = false;
    if (this.is_subscription_order && (!this.checkoutForm.value.delivery_date || !this.checkoutForm.value.delivery_time)) {
      this.checkoutForm.get('delivery_date').setValue('2023-01-01');
      this.checkoutForm.get('delivery_time').setValue('12:00');
    }
    
    if (this.debugOn) {
      const invalid = [];
      const controls = this.checkoutForm.controls;
      for (const name in controls) {

        if (controls[name].invalid) {
          invalid.push(name);
        }
      }

      console.log('invalid : ', invalid);
    }

    //this.keyboard.disableScroll(false);
    let d_date = this.checkoutForm.value.delivery_date;
    if (this.checkoutForm.valid) {
      // trick the checkout form, more details in above 
      if (resetDataInDeliveryDateTime) {
        this.checkoutForm.get('delivery_date').setValue('');
        this.checkoutForm.get('delivery_time').setValue('');
      }

      if (this.checkoutForm.value.delivery_time == 'asap') {
        d_date = 'asap';
      }
      let checkoutdetails = this.checkoutForm.value;
      this.appService.appObject.orderObject.order_details.name = checkoutdetails.name.trim();
      this.appService.appObject.orderObject.order_details.email = checkoutdetails.email.trim();
      this.appService.appObject.orderObject.order_details.mobile_number = checkoutdetails.mobile_number;
      this.appService.appObject.orderObject.order_details.backyard = checkoutdetails.backyard;
      this.appService.appObject.orderObject.order_details.special_note = checkoutdetails.special_note;
      this.appService.appObject.orderObject.order_details.payment_type = checkoutdetails.payment_method;
      this.appService.appObject.orderObject.order_details.delivery_date = d_date;
      this.appService.appObject.orderObject.order_details.delivery_time = checkoutdetails.delivery_time;
      this.appService.appObject.orderObject.order_details.delivery_type = this.appService.appObject.selectedDeliveryMethod;
      this.appService.appObject.orderObject.order_details.is_subscription_order = checkoutdetails.is_subscription_order;
      this.appService.appObject.orderObject.order_details.order_schedule_type = checkoutdetails.order_schedule_type;
      this.appService.appObject.orderObject.order_details.order_days = checkoutdetails.order_days;
      this.appService.appObject.orderObject.order_details.is_end_date = checkoutdetails.is_end_date;
      this.appService.appObject.orderObject.order_details.end_date = checkoutdetails.end_date;
      this.appService.appObject.orderObject.order_details.start_date = checkoutdetails.start_date;
      // console.log('this.appService.appObject.myAddress.name : ', this.appService.appObject.myAddress.name);

      // <---------------- (including) Gather address book data START ----------------->
      let addressBookObject = {
        id: null,
        street: '',
        houseNumber: '',
        postalCode: '',
        city: '',
        is_postalcode_mode: 'false'
      }

      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode !== 'true') {
        let streetNumber = checkoutdetails.street_number.trim();
        this.appService.appObject.addressBookObject.houseNumber = streetNumber;

        if (streetNumber && this.currentlySelectedAddress) {
          let splitedAddress = this.currentlySelectedAddress.split(',');
          // console.log('splited  3 : ' , splitedAddress);
          let newAddress = '';
          if (splitedAddress.length === 3) {
            newAddress = splitedAddress[0].trim() + ', ' + streetNumber + ', ' + splitedAddress[1].trim() + ', ' + splitedAddress[2].trim();
            this.appService.appObject.addressBookObject.street = splitedAddress[0].trim();
            this.appService.appObject.addressBookObject.postalCode = splitedAddress[1].trim();
            this.appService.appObject.addressBookObject.city = splitedAddress[2].trim();
          } else if (splitedAddress.length === 4) {
            newAddress = splitedAddress[0].trim() + ', ' + streetNumber + ', ' + splitedAddress[2].trim() + ', ' + splitedAddress[3].trim();
            this.appService.appObject.addressBookObject.street = splitedAddress[0].trim();
            this.appService.appObject.addressBookObject.postalCode = splitedAddress[2].trim();
            this.appService.appObject.addressBookObject.city = splitedAddress[3].trim();
            // console.log('splited  4 : ' , splitedAddress);
          }
          this.appService.appObject.myAddress.name = newAddress;
        }
      } else if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
        this.appService.appObject.myAddress.name = checkoutdetails.address.trim();
        let streetNumber = checkoutdetails.street_number.trim();

        this.appService.appObject.addressBookObject.is_postalcode_mode = 'true';
        this.appService.appObject.addressBookObject.houseNumber = streetNumber;
        this.appService.appObject.addressBookObject.city = this.postalCodeDetails.name;
        this.appService.appObject.addressBookObject.postalCode = this.postalCodeDetails.code;

        // let houseNumber = checkoutdetails.house_number.trim();
        // concat postal code details to end of the user entered address
        if (this.appService.appObject.myAddress.name) {
          this.appService.appObject.myAddress.name += (' ' + streetNumber) + (', ' + this.postalCodeDetails.name + ' ' + this.postalCodeDetails.code);
        }
      }

      // set address book object to app object  
      // if (this.appService.appObject.selectedDeliveryMethod === 'delivery') {
      //   this.appService.appObject.addressBookObject = addressBookObject;
      //   this.appService.updateAppObject();
      // }
      // <---------------- Gather address book data END ----------------->

      // check address string only if the selected ordering method is delivery
      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && !this.appService.appObject.myAddress.name) {
        this.showSelectAddressError = true;
        return;
      }

      if (!this.appService.isWebVersion) this.appService.placeOrder();
      else {
        let paymentOp = this.appService.appObject.orderObject.order_details.payment_type;
        if (paymentOp === 'cod' || paymentOp === 'ecCard' || paymentOp === 'points') {
          this.appService.placeOrder(true).then((response: any) => {
            if (response.payment_id) this.onOrderPlaced.emit([response.payment_id, this.appService.appObject.selectedDeliveryMethod]);
          }).catch((error) => {
            console.log('user canceled or error ', error);
          })
        } else {
          this.appService.placeOrder(true);
        }
      }

      // keep last order postal code details after placing an order
      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
        this.appService.appObject.postalCodeExtraDetails = {
          streetNumber: checkoutdetails.street_number.trim(),
          address: checkoutdetails.address.trim()
        }

        this.appService.updateAppObject();
      }

    } else {
      if (this.checkoutForm.controls.name.status == "INVALID") {
        document.getElementById("name").focus();
      } else if (this.checkoutForm.controls.email.status == "INVALID") {
        document.getElementById("email").focus();
      } else if (this.checkoutForm.controls.mobile_number.status == "INVALID") {
        document.getElementById("mobile_number").focus();
      }

    }

  }

  ngOnInit() {
    //var date = new Date();
    //this.todayDate = this.datePipe.transform(date, "yyyy-MM-dd");
    // console.log(this.todayDate);

  }

  async getDays(e) {
    // console.log('get days:', e.detail.value);

    if (/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(e.detail.value)) {

      this.selectedTimes = this.deleveryAvailableTimes[e.detail.value];
      this.selectedDate = e.detail.value;

    } else {

      this.selectedTimes = this.deleveryAvailableTimes[this.todayDate];
      this.selectedDate = this.todayDate;
    }


    this.checkoutForm.get('delivery_time').setValue('');

  }

  async getDeliveryTimes() {
    this.appService.getOpenTimes().then(data => {
      if (data.status) {
        // console.log(data.data);
        this.deleveryAvailableTimes = data.data;
        this.todayDate = data.today;
        this.maxDate = data.maxDate;


        Object.keys(data.data).forEach(key => {
          this.deliveryDates.push(key);
          if (key === this.todayDate) {
            // console.log('selecting', key);
            this.selectedDate = this.todayDate;

          }
        });

        setTimeout(() => {
          this.checkoutForm.get('delivery_date').setValue(this.selectedDate);
          // call get days function to trigger (ionChange) event manually in delivery_date select list,
          // otherwise it won't call because of ngIf condition in select list
          this.getDays({ detail: { value: this.selectedDate } });

          if (this.selectedDate == this.todayDate && !this.appService.appObject.selectedRestaurantDetails?.openDetails?.is_pre_order) {
            // check if the selected ordering option is available only for preorder,
            // if it is, then do not display asap option
            let preOrderAvailability = this.appService.findSelectedRestaurantOrderTypesV2(this.appService.appObject.selectedRestaurantDetails, true).preorderOptions;
            let onlyAvailableForPreorder = preOrderAvailability && preOrderAvailability[this.appService.appObject.selectedDeliveryMethod] ? true : false;

            if (!onlyAvailableForPreorder) {
              this.displayAsapOption = true;
              this.checkoutForm.get('delivery_time').setValue('asap');
            }
          } else if (this.selectedDate == this.todayDate && this.appService.appObject.selectedRestaurantDetails?.openDetails?.is_pre_order) {
            // set first value as default value
            if (this.selectedTimes.length) this.checkoutForm.get('delivery_time').setValue(this.selectedTimes[0]);
          }
          this.selectedTimesLoading = false;

          // check if there are unavailable dishes in cart with default order times
          this.onTimeChangeOrCartChange();
        }, 1000);



      } else {
        this.selectedTimesLoading = false;
      }
    }, error => {
      this.appService.appObject.isLoading = false;
      this.selectedTimesLoading = false;
    });
  }

  emailvalidation() {
    if (this.checkoutForm.value.email) {
      this.checkoutForm.get('email').setValue(this.checkoutForm.value.email.trim());
    }
  }

  /**
   * This will redirect user to given route
   * @param location string value of route path
   */
  async navigateTo(slug) {
    if (!this.appService.isWebVersion)
      this.router.navigate([slug === 'tnc' ? '/pages/tnc' : '/pages/pnp'])
    else {
      this.onNavigatePages.emit([slug]);
    }
  }

  /**
   * When user change address
   */
  changeDeliveryLocation() {
    if (!this.appService.isWebVersion) this.openAddressChangePopup()// this.router.navigate(['/find-near-by-me'])
    else this.onChangeDeliveryAddress.emit();
  }

  /**
   * When user change Payment Method
   */
  OnChangePaymentMethod($event) {
    this.selectedRadio = $event?.target?.value;
  }

  async openAddressChangePopup() {

    const modal = await this.modalController.create({
      component: SelectOrderTypePage,
      cssClass: 'custom-popup',

      componentProps: {
        'currentUI': 'delivery-address',
        'just_select_address': 'true',
        'is_from_checkout_page': 'true'
      }
    });

    await modal.present();

    modal.onDidDismiss().then((dismissed) => {
      this.onDismissAddressSelect();
    });
  }

  onDismissAddressSelect() {
    if (this.appService.appObject.myAddress && this.appService.appObject.myAddress.name && this.appService.appObject.myAddress.lat && this.appService.appObject.myAddress.lng) {
      this.currentlySelectedAddress = this.appService.appObject.myAddress.name;
      // auto fill the street number if available from previousely selected valid address
      this.street_number = this.appService.appObject.myAddress && this.appService.appObject.myAddress.streetNo ? this.appService.appObject.myAddress.streetNo : '';
    } else {
      this.currentlySelectedAddress = '';
      this.street_number = '';
    }
  }

  /**
   * Login in from points reward warnning message
   */
  loginInClicked() {
    if (!this.appService.isWebVersion) {
      this.router.navigate(['login'], { queryParams: { isOrderProcess: true } });
    } else {
      this.onBackLoginFromCheckout.emit();
    }
  }

  /**
   * 
   * get languages
   */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

  /**
   * Will check selected dishes menu categories are available or not at the selected order date and time
   * @returns nothing
   */
  checkMenuCategoriesAvailability() {
    let unavailableMenus = [];
    let unavalableDishes = [];

    this.unavailableMenus = [];
    this.appService.unavailableDishes = [];

    if (!this.is_subscription_order && this.checkoutForm.value.delivery_date && this.checkoutForm.value.delivery_time && this.appService.appObject.orderObject && this.appService.appObject.orderObject.cart) {
      let orderDate = this.checkoutForm.value.delivery_date;
      let orderTime = this.checkoutForm.value.delivery_time;
      // get user selected date name, ex : MON / TUE
      const orderDay = this.daysOfWeek[new Date(orderDate).getDay()];

      // If the user has selected order time as ASAP, then get current time in HH:MM format as orderTime
      if (orderTime == 'asap') {
        let currentTime = new Date();
        orderTime = currentTime.getHours().toString().padStart(2, '0') + ':' + currentTime.getMinutes().toString().padStart(2, '0');
      }

      // get all the cart items that user has selected
      let cartItems = this.appService.appObject.orderObject.cart;
      for (let i = 0; i < cartItems.length; i++) {
        const dish = cartItems[i];
        // findout the menu category of the dish
        let menuCategory = this.appService.menuList.find((menu) => menu.id === dish.menu_category_id);

        if (menuCategory && menuCategory.visibility) {
          let visibility = JSON.parse(menuCategory.visibility);
          let orderVisibility = visibility.find((day) => day.day === orderDay);

          let notAvailable = false;

          // If the category is available whole day, then ignore it
          if (orderVisibility.timeSlot && orderVisibility.timeSlot.from === 'All Day') {
            // return;
          } else {
            let currentDate = this.appService.formatDateObject(new Date(), false);
            let visibilityFrom = new Date(currentDate + ' ' + orderVisibility.timeSlot.from);
            let visibilityTo = new Date(currentDate + ' ' + orderVisibility.timeSlot.to);
            let orderTimeAsDate = new Date(currentDate + ' ' + orderTime);

            if (visibilityFrom.getTime() > orderTimeAsDate.getTime()) { // if the available time not reached yet
              // console.log('Not Available Yet');
              notAvailable = true;
            } else if (visibilityTo.getTime() < orderTimeAsDate.getTime()) { // if the available time has passed
              // console.log('Available Time Passed');
              notAvailable = true;
            } else {
              // console.log('Available to Order');
            }

            if (notAvailable) {
              unavalableDishes.push(dish)

              let exists = unavailableMenus.find((item) => item.menu_id === menuCategory.id)
              if (!exists) {
                unavailableMenus.push({
                  menu_id: menuCategory.id,
                  name: menuCategory.name,
                  availableAt: {
                    from: orderVisibility.timeSlot.from,
                    to: orderVisibility.timeSlot.to
                  }
                })
              }
            }
          }
        }
      }
    } else if (this.is_subscription_order) {
      // get all the cart items that user has selected
      let cartItems = this.appService.appObject.orderObject.cart;
      for (let i = 0; i < cartItems.length; i++) {
        const dish = cartItems[i];
        // findout the menu category of the dish
        let menuCategory = this.appService.menuList.find((menu) => menu.id === dish.menu_category_id);

        if (menuCategory && menuCategory.visibility) {
          let visibility = JSON.parse(menuCategory.visibility);

          let notAvailable = [];

          // if (this.checkoutForm.value.order_schedule_type === 'daily') {
          //   notAvailable = visibility.filter((dayData) => !dayData.isActive);
          // } else 
          if (this.checkoutForm.value.order_schedule_type === 'weekly' && this.checkoutForm.value.order_days) {
            // check selected menu categories availability for selected week days 
            notAvailable = visibility.filter((dayData) => this.checkoutForm.value.order_days.includes((dayData.day + '').toUpperCase()) && !dayData.isActive);
          }

          // console.log(menuCategory.name , ' | Visibility : ' , visibility);
          if (notAvailable.length) {
            unavalableDishes.push(dish)

            let exists = unavailableMenus.find((item) => item.menu_id === menuCategory.id)
            if (!exists) {
              unavailableMenus.push({
                menu_id: menuCategory.id,
                name: menuCategory.name,
                availability: visibility
              })
            }
          }
        }
      }
    }

    // console.log('unavalable menus : ', unavailableMenus);
    this.unavailableMenus = unavailableMenus;
    this.appService.unavailableDishes = unavalableDishes;
    return this.unavailableMenus.length;
  }


  /**
   * open cart pop up to show dishes that not available for order date and time
   */
  async openCartPopup() {
    if (!this.appService.isWebVersion) {
      this.appService.hideCartButton = true;

      const cartModal = await this.modalController.create({
        component: CartPage,
        cssClass: 'custom-popup',
        componentProps: { highlightUnavailableDishes: true }
      });

      await cartModal.present();

      cartModal.onDidDismiss().then((data) => {
        this.appService.hideCartButton = false;
        this.onTimeChangeOrCartChange();
      });
    }
  }
  /**
   * Check dish availability when time change or cart item change
   * @returns 
   */
  onTimeChangeOrCartChange() {
    this.showMenuCategoriesNotAvailableError = false;
    if (this.checkMenuCategoriesAvailability()) {
      this.showMenuCategoriesNotAvailableError = true;
    }
  }

  getTomorrow() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return this.formatDate(tomorrow);
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  async selectType(e) {
    // when user trigger subscription types, check menu category availability
    this.showMenuCategoriesNotAvailableError = false;
    if (this.checkMenuCategoriesAvailability()) {
      this.showMenuCategoriesNotAvailableError = true;
    }
    // if (e.detail.value === 'daily') {
    //   this.checkoutForm.get('start_date').setValue(this.nextDay());
    // }
    // if (e.detail.value === 'weekly') {
    //   this.checkoutForm.get('start_date').setValue('');
    // }
  }

  async selectDats(e) {

    if (this.checkoutForm.value.order_days.length > 0) {
      var check = this.checkIsTimePassed(this.subscription_order_cutoff_time)
      var getTodayPlusGivenDay: any;
  
      if (check) {
        getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(this.subscription_order_cutoff_days) + 2, this.subscription_order_cutoff_time);
      }
      if (!check) {
        getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(this.subscription_order_cutoff_days) + 1, this.subscription_order_cutoff_time);
      }
  
      let dateList = [];
  
      for (let index = 0; index < e.detail.value.length; index++) {
        let daynumber = await this.dayNum(e.detail.value[index]);
        var d = new Date(getTodayPlusGivenDay);
        d.setDate(d.getDate() + (daynumber + 7 - d.getDay()) % 7);
        dateList.push(d);
      }
  
      let sorted = dateList.sort((a, b) => a.getTime() - b.getTime());
  
      // this will indicate that startDateChange event will be called due to the below code execution.
      // and we should void that 
      this.isAboutToTriggerStartDateChange = true;
      this.checkoutForm.get('start_date').setValue(this.formatDate(sorted[0]));
      this.checkoutForm.get('suggest_start_day').setValue(this.formatDate(sorted[0]));
      this.minDate = this.formatDate(sorted[0]);
  
      // when user select subsription type as weekly and select dates, check menu category availability
      this.showMenuCategoriesNotAvailableError = false;
      if (this.checkMenuCategoriesAvailability()) {
        this.showMenuCategoriesNotAvailableError = true;
      }
      this.isAboutToTriggerStartDateChange = false;
    }

  }

  async dayNum(value) {
    // console.log('EE',value);
    if (value === 'MON') {
      return 1;
    }
    if (value === 'TUE') {
      return 2;
    }
    if (value === 'WED') {
      return 3;
    }
    if (value === 'THU') {
      return 4;
    }
    if (value === 'FRI') {
      return 5;
    }
    if (value === 'SAT') {
      return 6;
    }
    if (value === 'SUN') {
      return 7;
    }
  }

  onSubscriptionOrderCheckBoxChange() {
    this.showMenuCategoriesNotAvailableError = false;
  }


  getTodayPlusGivenDaysDay(givendays, giventime) {
    const today = new Date();
    const plusDay = new Date(today);
    const pday = today.setDate(plusDay.getDate() + givendays);
    var onlyday = this.formatDate(pday);
    return new Date(onlyday + ' : ' + giventime);
  }

  // nextDay() {
  //   if (this.checkoutForm?.value?.order_schedule_type === 'weekly') {
  //     // var check = this.checkIsTimePassed(this.subscription_order_cutoff_time)
  //     // console.log('check ',check);
  //     // var getTodayPlusGivenDay: any;
  //     // if (check) {
  //     //   getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(this.subscription_order_cutoff_days) + 2, this.subscription_order_cutoff_time);
  //     // }
  //     // if (!check) {
  //     //   getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(this.subscription_order_cutoff_days) + 1, this.subscription_order_cutoff_time);
  //     // }
  //     // if (!isNaN(getTodayPlusGivenDay)) {
  //     //   return this.formatDate(getTodayPlusGivenDay);
  //     // }
  //   } else {
  //     var check = this.checkIsTimePassed(this.subscription_order_cutoff_time)
  //     var getTodayPlusGivenDay: any;
  //     if (check) {
  //       getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(this.subscription_order_cutoff_days) + 2, this.subscription_order_cutoff_time);
  //     }
  //     if (!check) {
  //       getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(this.subscription_order_cutoff_days) + 1, this.subscription_order_cutoff_time);
  //     }
  //     if (!isNaN(getTodayPlusGivenDay)) {
  //       for (let index = 0; index < 6; index++) {
  //         if (this.daysOfWeek[new Date(getTodayPlusGivenDay).getDay()] === this.available_days[index].day) {
  //           if (this.available_days[index].isActive === 'true') {
  //             return this.formatDate(getTodayPlusGivenDay);
  //           } else {
  //             this.subscription_order_cutoff_days = parseInt(this.subscription_order_cutoff_days) + 1;
  //             this.nextDay();
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  checkIsTimePassed(giventime) {
    var get_day = this.getTodayPlusGivenDaysDay(0, giventime);
    var now = new Date();
    var d = new Date(get_day); // pass all the parameters you need to create the time
    if (now.getTime() > d.getTime()) {
      // the date stored in `d` is in the past.
      return true;
    } else {
      return false;
    }
  }

  async selectStartDate(e) {
    // check this function is trigged by user action or datechange event
    if (this.isAboutToTriggerStartDateChange) {
      // if this is not triggered by user action then reset the value for next time operation
      // and return to avoid executing below code, which we want to do..
      this.isAboutToTriggerStartDateChange = false;
      return;
    }
    if (e.detail.value === this.checkoutForm.value.start_date) {
      this.checkoutForm.get('start_date').setValue(this.formatDate(e.detail.value));
      this.checkoutForm.get('suggest_start_day').setValue(this.formatDate(e.detail.value));
    }
    if (this.checkoutForm?.value?.order_schedule_type === 'weekly' && this.checkoutForm.value.order_days.length > 0) {
      var check = this.checkIsTimePassed(this.subscription_order_cutoff_time)
      var getTodayPlusGivenDay: any;

      if (check) {
        getTodayPlusGivenDay = this.getSelectePlusGivenDay(e.detail.value, parseInt(this.subscription_order_cutoff_days) + 2, this.subscription_order_cutoff_time);
      }
      if (!check) {
        getTodayPlusGivenDay = this.getSelectePlusGivenDay(e.detail.value, parseInt(this.subscription_order_cutoff_days) + 1, this.subscription_order_cutoff_time);
      }

      console.log('Get Today Plus GivenDay :', this.checkoutForm.value.order_days);

      let dateList = [];

      for (let index = 0; index < this.checkoutForm.value.order_days.length; index++) {
        let daynumber = await this.dayNum(this.checkoutForm.value.order_days[index]);
        var d = new Date(getTodayPlusGivenDay);
        d.setDate(d.getDate() + (daynumber + 7 - d.getDay()) % 7);
        dateList.push(d);
      }

      let sorted = dateList.sort((a, b) => a.getTime() - b.getTime());

      // this will indicate that startDateChange event will be called due to the below code execution.
      // and we should void that 
      this.isAboutToTriggerStartDateChange = true;
      this.checkoutForm.get('start_date').setValue(this.formatDate(sorted[0]));
      this.minDate = this.formatDate(sorted[0]);
    }
  }

  /**
   * Will trigger when user change the address in address book select list
   * @param eve address change event object
   */
  async onAddressSelect(eve) {
    if (eve && eve.detail && eve.detail.value) {
      this.addressSelectActionTriggered = true;
      let addressBookObject = eve.detail.value;
      this.changingAddressInProgress = true;

      if (this.appService.appObject.settings.is_postalcode === 'true') {
        // console.log('postal code mode : ', addressBookObject);
        // console.log('selected postal code : ' , this.appService.appObject.postalCodeDetails);

        if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.postal_code_details) {
          let postalCodeDetails = this.appService.appObject.selectedRestaurantDetails.postal_code_details;
          let postalCodeFound = postalCodeDetails.find((postalCode) => postalCode.code === addressBookObject.postal_code);
          if (postalCodeFound) {
            // there is modification needed to postal code object pricing to do calculations in appService calculate cart amount function
            let copyOfPostalSelected = { ...postalCodeFound };
            if (!copyOfPostalSelected.price) {
              copyOfPostalSelected.price = [{ restaurantId: this.appService.appObject.selectedRestaurantDetails.id, cost: copyOfPostalSelected.cost, minOrderAmount: copyOfPostalSelected.min_order }];
            } else {
              let found = copyOfPostalSelected.price.find((pric) => pric.restaurantId === this.appService.appObject.selectedRestaurantDetails.id);
              found = { restaurantId: this.appService.appObject.selectedRestaurantDetails.id, cost: copyOfPostalSelected.cost, minOrderAmount: copyOfPostalSelected.min_order };
            }

            this.appService.appObject.postalCodeDetails = copyOfPostalSelected;
            this.postalCodeDetails = copyOfPostalSelected;
            this.appService.appObject.myAddress.name = addressBookObject.address;
            this.appService.appObject.addressObjectForPostalCode.street = addressBookObject.street;
            this.currentlySelectedAddress = addressBookObject.address;
            this.appService.appObject.addressObjectForPostalCode.lon = addressBookObject.longitude;
            this.appService.appObject.addressObjectForPostalCode.lat = addressBookObject.latitude;
            this.checkoutForm.get('street_number').setValue(addressBookObject.house_number);
          } else {
            this.appService.showToast('Selected restaurant not delivering to the selected area', 'danger');
          }
        }
      } else {
        await this.appService.findNearByRestaurants('', false);
        let found = this.appService.appObject.restaurants.find((rest) => rest.id === this.appService.appObject.selectedRestaurantDetails.id);

        if (!found) {
          this.appService.showToast('Selected restaurant not delivering to the selected address', 'danger');
        } else {
          this.appService.appObject.myAddress.name = addressBookObject.address;
          this.currentlySelectedAddress = addressBookObject.address;
          this.appService.appObject.myAddress.lat = addressBookObject.latitude;
          this.appService.appObject.myAddress.lng = addressBookObject.longitude;
          this.checkoutForm.get('street_number').setValue(addressBookObject.house_number);
          this.checkoutForm.get('backyard').setValue(addressBookObject.backyard);

          // get restaurant details again to calculate distance and delivery cost for changed address 
          await this.appService.getRestaurantBySlug(found.slug);
        }
      }
      // recalculate cart amounts with new address details
      await this.appService.calculateCartAmounts();
      this.appService.updateAppObject();
      this.changingAddressInProgress = false;
    }
  }

  getSelectePlusGivenDay(selectdate, givendays, giventime) {
    const myselectdate = new Date(selectdate);
    const plusDay = new Date(myselectdate);
    const pday = myselectdate.setDate(plusDay.getDate() + givendays);
    var onlyday = this.formatDate(pday);
    return new Date(onlyday + ' : ' + giventime);
  }

}